import React from 'react';
import PropTypes from 'prop-types';
import { Calendar as CoreCalendar } from '@sparefoot/react-core';
import classnames from 'classnames';

import './Calendar.scss';

export default function Calendar({ className, ...rest }) {
	return (
		<CoreCalendar
			{...rest}
			className={classnames(className, 'ss-calendar')}
		/>
	);
}

Calendar.propTypes = {
	className: PropTypes.string,
};
